/* ============================================================
   personnalisation-produit.js  v18.2
   v18.2 : plus de propriété « Marquage : 1 / 2 » (fausse après un retrait au panier) ; Face et Position suffisent.
   v18.1 : le marque-page personnalisé porte une propriété cachée _mp (jamais fusionné avec un autre au panier) ;
           date : le format est contrôlé avant la largeur (message juste pour « 28/06/1999 » en grande taille).
   v18 : prix total sous la miniature (colonne collante), avec l'écart affiché un instant à chaque changement.
   v17 : modifier depuis le panier (?mp_edit=<clé>) : marquages relus dans les propriétés des lignes,
         « Mettre à jour le panier » remplace l'article et renvoie au panier.
   v16 : jusqu'à 4 marquages par marque-page, chacun à son emplacement (face + position, ou
         vertical sur toute une face), avec son motif, sa finition et son prix ; chaque marquage
         devient une ligne « Personnalisation » rattachée au marque-page dans le panier.
         L'éditeur travaille sur le marquage courant (state) ; les autres sont conservés dans
         `markings` et rendus via withMarking().
   v15 : la personnalisation est rattachée au marque-page dans le panier (lignes imbriquées,
         parent_id, Dawn ≥ 15.4), en un seul appel ; repli sur l'ajout séquentiel si refusé.
   v14 : bilingue FR / EN — tous les textes viennent de locales/*.json (meleniewska.perso_js),
         transmis par le snippet dans #mp-perso-i18n ; repérage des cuirs foncés indépendant de la langue.
   v13 : motif « Texte » (plusieurs lignes, horizontal ou vertical),
         prix calculé (base + caractères + lignes + dorure) et retrouvé
         parmi les variantes du produit perso, contrôle du stock de caractères du
         composteur, rendu à l'échelle réelle (Cinzel, 4 mm de capitale).
   Généralisé : lit la config depuis data-perso-* attributes.
   ============================================================ */

(function () {
  'use strict';

  var $ = function(id) { return document.getElementById(id); };

  var module = $('mp-perso-module');
  if (!module) return;

  /* ── Textes (FR / EN) — locales/*.json → meleniewska.perso_js ────────── */
  var I18N = {};
  try { I18N = JSON.parse(($('mp-perso-i18n') || {}).textContent || '{}') || {}; }
  catch (e) { console.warn('[mp-perso] Textes illisibles', e); }
  // T('cle', { n: 3 }) → texte avec {n} remplacé ; T.n('cle', n, vars) choisit cle_one / cle_other
  function T(key, vars) {
    var s = I18N[key];
    if (s == null) { console.warn('[mp-perso] Texte manquant : ' + key); return ''; }
    if (vars) for (var k in vars) s = s.split('{' + k + '}').join(vars[k]);
    return s;
  }
  T.n = function(key, n, vars) {
    vars = vars || {}; vars.n = n;
    return T(key + (n > 1 ? '_other' : '_one'), vars);
  };
  function fmtMm(v) { return v.toString().replace('.', T('decimal') || '.'); }

  /* ══════════
     RÉGLAGES ATELIER — les seuls chiffres à ajuster à la main
     ══════════ */
  var ATELIER = {
    BOOKMARK_MM:    { w: 40, h: 140 },   // dimensions du marque-page
    CAP_MM:         4,                   // hauteur des capitales marquées
    CAP_HEIGHT_EM:  0.70,                // Cinzel : capitale = 0,70 em (métrique de la police)
    TRACKING_EM:    0.12,                // espace entre lettres (à calibrer sur un vrai marquage)
    LINE_PITCH_MM:  6.5,                 // interligne entre deux lignes de lettres (de centre à centre)
    LINE_GAP_MM:    2.5,                 // blanc entre deux lignes (sert quand une ligne contient une étoile)
    // Étoiles : fers individuels (pas de limite de stock), même diamètre pour les deux modèles
    STAR_MM:        7.5,                 // diamètre des étoiles (à changer le jour où il y aura des fers plus petits)
    STAR_WEIGHT:    3,                   // une étoile compte pour 3 caractères dans le prix
    STARS:          { '★': 'pleine', '☆': 'contour' },
    HORIZONTAL:     { maxLines: 3, usableMm: 35 },   // largeur utile : 40 mm − 2 × 2,5 mm
    VERTICAL:       { maxLines: 3, usableMm: 116 },  // longueur utile : 140 mm − 2 × 12 mm
    MAX_CHARS:      24,                  // lettres et chiffres au maximum (toutes lignes)
    // Dates : tolérées au-delà de la largeur utile (marquées en deux frappes), mais jamais plus larges que le marque-page
    DATE_MAX_MM:    40,
    // Tarif : base + caractères au-delà des inclus + lignes supplémentaires + dorure.
    // Les montants doivent exister en variantes du produit « Personnalisation » (option « Prix »).
    PRICING:        { base: 9, includedChars: 3, perChar: 1, perExtraLine: 5, foil: 4 },
    // Stock du composteur — contrôlé ligne par ligne (le composteur est recomposé à chaque ligne)
    STOCK_LETTER:   4,
    STOCK_DIGIT:    3,
    STOCK_SPECIAL:  { 'Ç': 2, '.': 2, ',': 2, ';': 2, ':': 2, '(': 2, ')': 2, '-': 2 },
    // Petit alphabet 1,6 mm — chiffres et barre oblique uniquement (dates)
    SMALL: { CAP_MM: 1.6, STOCK_LETTER: 0, STOCK_DIGIT: 3, STOCK_SPECIAL: { '/': 3 } },
  };
  var EM_MM = ATELIER.CAP_MM / ATELIER.CAP_HEIGHT_EM;             // 1 em = 5,71 mm
  // Chasse des glyphes Cinzel SemiBold (en em) — permet de mesurer sans attendre la police
  var GLYPH_EM = {"A":0.715,"B":0.645,"C":0.773,"D":0.821,"E":0.613,"F":0.577,"G":0.824,"H":0.845,"I":0.370,"J":0.364,"K":0.724,"L":0.598,"M":0.946,"N":0.857,"O":0.865,"P":0.630,"Q":0.867,"R":0.724,"S":0.544,"T":0.650,"U":0.809,"V":0.732,"W":0.975,"X":0.707,"Y":0.689,"Z":0.658,"0":0.634,"1":0.376,"2":0.596,"3":0.543,"4":0.607,"5":0.536,"6":0.607,"7":0.530,"8":0.586,"9":0.607,".":0.208,",":0.215,";":0.215,":":0.208,"(":0.395,")":0.395,"-":0.380,"Ç":0.773," ":0.250};
  GLYPH_EM['★'] = GLYPH_EM['☆'] = ATELIER.STAR_MM / EM_MM;      // largeur d'une étoile, en em du texte
  var RE_ALLOWED_CHAR = /^[A-Z0-9Ç.,;:()\-★☆ ]$/;
  var RE_STAR = /[★☆]/;
  var STAR_GLYPH_RATIO = 0.8;   // hauteur visible du glyphe ★ / taille de police (approx.)

  /* ── Config depuis data-* attributes ────────── */
  var DEFAULTS = {
    faces: [{"key":"recto","label":"Recto","img_alt":"recto"},{"key":"verso","label":"Verso","img_alt":"verso"}],
    positions: {"recto":["haut"],"verso":["haut","bas"]},
    overlayCoords: {"rectoHaut":{"top":18,"left":50},"versoHaut":{"top":18,"left":50},"versoBas":{"top":82,"left":50}},
    motifs: ["etoile","date4"],
    orientations: {"verso":["horizontal","vertical"]},
  };

  function parseAttr(attr, fallback) {
    var raw = module.dataset[attr] || '';
    if (!raw || raw === 'null') return fallback;
    try {
      var parsed = JSON.parse(raw);
      // Si le résultat est une string, c'est peut-être du double-encoding
      if (typeof parsed === 'string') {
        try { parsed = JSON.parse(parsed); } catch(e2) { /* pas du double-encoding */ }
      }
      return parsed == null ? fallback : parsed;
    }
    catch(e) { console.warn('[mp-perso] JSON invalide pour ' + attr + ':', raw, e); return fallback; }
  }

  var faces         = parseAttr('persoFaces', DEFAULTS.faces);
  var positions     = parseAttr('persoPositions', DEFAULTS.positions);
  var overlayCoords = parseAttr('persoOverlayCoords', DEFAULTS.overlayCoords);
  var motifs        = parseAttr('persoMotifs', DEFAULTS.motifs);
  var orientations  = parseAttr('persoOrientations', DEFAULTS.orientations);

  if (faces.length === 0) {
    console.warn('[mp-perso] Aucune face configurée');
    return;
  }

  /* Logo : zone « <face>Logo » dans perso_overlay_coords, ex. "rectoLogo": {"top":83,"left":50,"width":18,"height":6}
     (en % de la photo). Si elle est présente, l'option « sans logo » est proposée et le logo est
     masqué sur la photo par un morceau de cuir prélevé juste au-dessus (décalage src_dy, en %). */
  var logoZone = null;
  faces.forEach(function(face) {
    var c = overlayCoords[face.key + 'Logo'];
    if (!logoZone && c && c.top != null) {
      logoZone = { key: face.key + 'Logo', faceKey: face.key, position: 'logo', orientation: 'logo', kind: 'logo',
                   coords: { top: +c.top, left: c.left != null ? +c.left : 50, width: +(c.width || 18), height: +(c.height || 6),
                             src_dy: +(c.src_dy || 9) } };
    }
  });

  /* ── Éléments ────────── */
  var checkbox         = $('mp-perso-checkbox');
  var panel            = $('mp-perso-panel');
  var svgRecto         = $('mp-svg-recto');
  var svgVerso         = $('mp-svg-verso');
  var previewHint      = $('mp-preview-hint');
  var initialesSection = $('mp-initiales-section');
  var dateSection      = $('mp-date-section');
  var texteSection     = $('mp-texte-section');
  var orientSection    = $('mp-orientation-section');
  var positionSection  = $('mp-position-section');
  var positionPills    = $('mp-position-pills');
  var faceSection      = $('mp-face-section');
  var facePills        = $('mp-face-pills');
  var motifChoices     = $('mp-motif-choices');
  var introText        = $('mp-perso-intro-text');
  var initialesInput   = $('mp-initiales-input');
  var initialesError   = $('mp-initiales-error');
  var dateInput        = $('mp-date-input');
  var dateError        = $('mp-date-error');
  var texteInput       = $('mp-texte-input');
  var texteError       = $('mp-texte-error');
  var texteCounter     = $('mp-texte-counter');
  var texteHint        = $('mp-texte-hint');
  var priceEl          = $('mp-perso-price');
  var addBtn           = $('mp-perso-add-btn');
  var confirmEl        = $('mp-perso-confirm');
  var cartLink         = $('mp-perso-cart-link');
  // Les <text> statiques v12 sont conservés dans le HTML mais vidés : le rendu passe par drawSvgText()
  ['mp-text-recto', 'mp-text-v-haut', 'mp-text-v-bas'].forEach(function(id) {
    var el = $(id); if (el) el.style.display = 'none';
  });
  // Idem pour les cadres pointillés fixes : un cadre ajusté au texte est dessiné à la place
  [svgRecto, svgVerso].forEach(function(svg) {
    if (!svg) return;
    svg.querySelectorAll('rect[stroke-dasharray]').forEach(function(r) { r.style.display = 'none'; });
  });

  var persoVariantId = module.dataset.persoVariantId || '';
  var productTitle   = module.dataset.productTitle || '';
  // Le titre est traduit selon la langue : on reconnaît les deux
  var isDarkLeather  = /noir|black/i.test(productTitle);
  var isDarkBrown    = /russie|russia/i.test(productTitle);

  /* ── Helpers faces ────────── */
  function faceByKey(key) {
    return faces.find(function(f) { return f.key === key; }) || faces[0];
  }
  function faceLabel(key) {
    return faceByKey(key).label || key;
  }
  function positionsForFace(faceKey) {
    var list = (positions[faceKey] || []).slice();
    // Sans logo : la place du logo se libère, le marquage peut aller en bas de cette face
    if (state && state.noLogo && logoZone && logoZone.faceKey === faceKey &&
        overlayCoords[faceKey + 'Bas'] && list.indexOf('bas') === -1) list.push('bas');
    return list;
  }
  // Toutes les positions possibles d'une face (avec ou sans logo) — pour créer les zones d'aperçu
  function allPositionsForFace(faceKey) {
    var list = (positions[faceKey] || []).slice();
    if (logoZone && logoZone.faceKey === faceKey && overlayCoords[faceKey + 'Bas'] && list.indexOf('bas') === -1) list.push('bas');
    return list;
  }
  function orientationsForFace(faceKey) {
    var o = orientations[faceKey];
    var list = (o && o.length) ? o.slice() : ['horizontal'];
    // Sans logo : toute la longueur de la face se libère, l'écriture verticale devient possible
    if (state && state.noLogo && logoZone && logoZone.faceKey === faceKey && list.indexOf('vertical') === -1) list.push('vertical');
    return list;
  }
  // Toutes les orientations possibles (avec ou sans logo) — pour créer les zones d'aperçu
  function allOrientationsForFace(faceKey) {
    var list = (orientations[faceKey] || []).slice();
    if (logoZone && logoZone.faceKey === faceKey && list.indexOf('vertical') === -1) list.push('vertical');
    return list;
  }
  // Position labels (capitalize first letter)
  function positionLabel(key) {
    return T('pos_' + key) || key.charAt(0).toUpperCase() + key.slice(1);
  }

  /* ── État local ────────── */
  var defaultFace = faces[0].key;
  var defaultPositions = positionsForFace(defaultFace);
  var state = {
    active: false,
    motif: 'initiales',
    initiales: '',
    date: '',
    dateSize: 'grande',   // 'grande' = 4 mm, 'petite' = 1,6 mm
    etoileType: 'pleine', // motif Étoile : 'pleine' (★) ou 'contour' (☆)
    texte: '',
    orientation: 'horizontal',
    face: defaultFace,
    position: defaultPositions[0] || 'haut',
    finition: 'ton-sur-ton',
    noLogo: false,
  };
  function effectiveOrientation() {
    return state.motif === 'texte' ? state.orientation : 'horizontal';
  }

  /* ══════════
     MARQUAGES MULTIPLES (v16)
     `state` porte le marquage en cours d'édition ; `markings[current]` n'est à jour qu'après
     saveCurrent(). allMarkings() renvoie toujours la liste complète et à jour.
     ══════════ */
  var MAX_MARKINGS = 4;
  var MARK_KEYS = ['motif', 'initiales', 'date', 'dateSize', 'etoileType', 'texte', 'orientation', 'face', 'position', 'finition'];
  function snapshot() { var m = {}; MARK_KEYS.forEach(function(k) { m[k] = state[k]; }); return m; }
  var markings = [snapshot()];
  var current = 0;
  var withDepth = 0;   // > 0 pendant withMarking() : `state` contient alors un autre marquage
  function saveCurrent() { if (!withDepth) markings[current] = snapshot(); }
  function allMarkings() { saveCurrent(); return markings.slice(); }
  // Exécute fn comme si le marquage m était le marquage courant (toutes les fonctions lisent `state`)
  function withMarking(m, fn) {
    var saved = snapshot();
    withDepth++;
    MARK_KEYS.forEach(function(k) { state[k] = m[k]; });
    try { return fn(); }
    finally { MARK_KEYS.forEach(function(k) { state[k] = saved[k]; }); withDepth--; }
  }
  function capFirst(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function isVerticalMarking(m) { return m.motif === 'texte' && m.orientation === 'vertical'; }
  function zoneKeyOf(m) { return isVerticalMarking(m) ? m.face + 'Vertical' : m.face + capFirst(m.position); }
  // Deux marquages se gênent s'ils sont sur la même face et au même endroit, ou si l'un est vertical
  function conflicts(a, b) {
    return a.face === b.face && (isVerticalMarking(a) || isVerticalMarking(b) || a.position === b.position);
  }
  // Les marquages autres que celui d'indice `except` (-1 : tous)
  function otherMarkings(except) {
    return allMarkings().filter(function(m, j) { return j !== except; });
  }
  function placementFree(cand, except) {
    return otherMarkings(except).every(function(o) { return !conflicts(cand, o); });
  }
  function horizontalAt(face, pos) { return { face: face, position: pos, motif: 'initiales', orientation: 'horizontal' }; }
  // Premier emplacement horizontal libre (pour un nouveau marquage ou un marquage déplacé)
  function freePlacement(except) {
    for (var i = 0; i < faces.length; i++) {
      var list = positionsForFace(faces[i].key);
      for (var j = 0; j < list.length; j++) {
        var cand = horizontalAt(faces[i].key, list[j]);
        if (placementFree(cand, except)) return cand;
      }
    }
    return null;
  }
  function canAddMarking() {
    return allMarkings().length < MAX_MARKINGS && !!freePlacement(-1);
  }
  function zoneLabel(m) {
    return isVerticalMarking(m)
      ? T('hint_vertical', { face: faceLabel(m.face) })
      : T('hint_position', { pos: positionLabel(m.position), face: faceLabel(m.face).toLowerCase() });
  }

  /* ══════════
     PRIX — règle unique pour tous les motifs :
       base + 1 € par lettre/chiffre au-delà de 3 + 5 € par ligne en plus + 4 € dorure
     Le montant calculé est retrouvé parmi les variantes du produit « Personnalisation »
     (une variante par montant : « 9 € », « 10 € », …).
     ══════════ */
  var persoVariants = [];
  (function readVariants() {
    var el = $('mp-perso-variants');
    if (!el) return;
    try { persoVariants = JSON.parse(el.textContent) || []; }
    catch(e) { console.warn('[mp-perso] Variantes illisibles', e); }
  })();

  // Lettres et chiffres = 1, étoile = STAR_WEIGHT ; ponctuation et espaces offerts
  function countStars(str) { return ((str || '').match(/[★☆]/g) || []).length; }
  function countPriced(str) {
    return ((str || '').match(/[A-Z0-9Ç]/g) || []).length + countStars(str) * ATELIER.STAR_WEIGHT;
  }

  function priceParts() {
    var P = ATELIER.PRICING;
    var chars, lines;
    switch (state.motif) {
      case 'etoile': chars = ATELIER.STAR_WEIGHT; lines = 1; break;
      case 'date4':  chars = countPriced(state.date); lines = 1; break;
      case 'texte':  var a = analyzeTexte(); chars = a.stamped; lines = Math.max(a.lines.length, 1); break;
      default:       chars = countPriced(initialesValue()); lines = 1;
    }
    var extraChars = Math.max(chars - P.includedChars, 0);
    var extraLines = Math.max(lines - 1, 0);
    var foil = state.finition !== 'ton-sur-ton';
    return {
      chars: chars, lines: lines, extraChars: extraChars, extraLines: extraLines, foil: foil,
      euros: P.base + extraChars * P.perChar + extraLines * P.perExtraLine + (foil ? P.foil : 0),
    };
  }

  function currentVariant() {
    if (!persoVariants.length) return persoVariantId ? { id: persoVariantId, price: null } : null;
    var cents = Math.round(priceParts().euros * 100);
    var v = persoVariants.find(function(x) { return x.price === cents && x.available !== false; });
    if (!v) console.warn('[mp-perso] Aucune variante à ' + cents / 100 + ' € dans le produit de personnalisation');
    return v || null;
  }
  function formatMoney(cents) {
    if (cents == null) return '';
    var v = cents / 100;
    var s = (v % 1 === 0) ? String(v) : v.toFixed(2).replace('.', T('decimal') || ',');
    return T('money', { n: s });
  }
  // Prix d'un marquage (centimes) : celui de la variante correspondante, à défaut le calcul
  function markingCents(m) {
    return withMarking(m, function() {
      var v = currentVariant();
      return v && v.price != null ? v.price : Math.round(priceParts().euros * 100);
    });
  }
  // Détail du prix du marquage courant (base, caractères, lignes, dorure, étoile)
  function priceBreakdown() {
    var p = priceParts(), P = ATELIER.PRICING, parts = [];
    if (p.extraChars) parts.push(T.n('extra_chars', p.extraChars, { p: formatMoney(p.extraChars * P.perChar * 100) }));
    if (p.extraLines) parts.push(T.n('extra_lines', p.extraLines, { p: formatMoney(p.extraLines * P.perExtraLine * 100) }));
    if (p.foil) parts.push(T(state.finition === 'dore' ? 'foil_gold' : 'foil_silver', { p: formatMoney(P.foil * 100) }));
    var hasStar = state.motif === 'etoile' || (state.motif === 'texte' && RE_STAR.test(normalizeText(state.texte).join('')));
    return (parts.length
      ? T('base_with_parts', { p: formatMoney(P.base * 100), n: P.includedChars }) + parts.join(' + ')
      : T('base_only', { n: P.includedChars }))
      + (hasStar ? T('star_counts', { n: ATELIER.STAR_WEIGHT }) : '');
  }
  /* Prix sous la miniature (colonne qui reste à l'écran) : le client voit le total changer pendant
     qu'il tape, sans avoir à descendre jusqu'au bouton. Un écart (« +1 € ») s'affiche un instant. */
  var miniPriceEl = null, miniDeltaEl = null, lastTotal = null, deltaTimer = null;
  function updateMiniPrice(total) {
    var col = module.querySelector('.mp-perso__col-svg');
    if (!col) return;
    if (!miniPriceEl) {
      var box = document.createElement('div');
      box.className = 'mp-perso__mini-price';
      miniPriceEl = document.createElement('span');
      miniPriceEl.className = 'mp-perso__mini-amount';
      miniPriceEl.setAttribute('aria-hidden', 'true');   // le prix de référence (lu par les lecteurs d'écran) reste celui du bouton
      miniDeltaEl = document.createElement('span');
      miniDeltaEl.className = 'mp-perso__mini-delta';
      miniDeltaEl.setAttribute('aria-hidden', 'true');
      box.appendChild(miniPriceEl); box.appendChild(miniDeltaEl);
      col.appendChild(box);
    }
    miniPriceEl.textContent = formatMoney(total);
    miniPriceEl.title = T('price_total_title', { p: formatMoney(total) });
    if (lastTotal !== null && total !== lastTotal && state.active) {
      var d = total - lastTotal;
      miniDeltaEl.textContent = (d > 0 ? '+' : '−') + formatMoney(Math.abs(d));
      miniDeltaEl.classList.add('is-visible');
      miniPriceEl.classList.remove('is-updated'); void miniPriceEl.offsetWidth; miniPriceEl.classList.add('is-updated');
      clearTimeout(deltaTimer);
      deltaTimer = setTimeout(function() { miniDeltaEl.classList.remove('is-visible'); }, 1800);
    }
    lastTotal = total;
  }
  var priceDetailEl = null, priceListEl = null;
  function updatePrice() {
    if (!priceEl) return;
    if (!priceDetailEl) {
      priceDetailEl = document.createElement('span');
      priceDetailEl.className = 'mp-perso__price-detail';
      priceDetailEl.style.cssText = 'display:block;font-size:0.82em;opacity:0.8;';
      priceListEl = document.createElement('span');
      priceListEl.className = 'mp-perso__price-list';
      priceListEl.style.cssText = 'display:block;font-size:0.82em;';
      var pl = $('mp-perso-preview-link');
      var parent = priceEl.parentNode;
      if (pl && pl.parentNode === parent) { parent.insertBefore(priceListEl, pl); parent.insertBefore(priceDetailEl, pl); }
      else { parent.appendChild(priceListEl); parent.appendChild(priceDetailEl); }
    }
    if (noLogoOnly()) {
      priceEl.textContent = formatMoney(0);
      priceDetailEl.textContent = ''; priceListEl.textContent = '';
      updateMiniPrice(0);
      return;
    }
    var list = allMarkings();
    var cents = list.map(markingCents);
    var total = cents.reduce(function(a, b) { return a + b; }, 0);
    priceEl.textContent = formatMoney(total);
    updateMiniPrice(total);
    // Plusieurs marquages : un montant par marquage, puis le détail de celui en cours d'édition
    priceListEl.textContent = list.length > 1
      ? list.map(function(m, i) { return T('marking_price', { n: i + 1, p: formatMoney(cents[i]) }); }).join(' · ')
      : '';
    priceDetailEl.textContent = (list.length > 1 ? T('marking_prefix', { n: current + 1 }) : '') + priceBreakdown();
  }

  /* ══════════
     TEXTE — normalisation, mesure, contrôle du composteur
     ══════════ */
  function normalizeText(raw) {
    var s = (raw || '').replace(/\r/g, '');
    s = s.replace(/[çÇ]/g, '\u0001');
    s = s.toUpperCase().replace(/Œ/g, 'OE').replace(/Æ/g, 'AE');
    s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    s = s.replace(/\u0001/g, 'Ç').replace(/[‐-—−]/g, '-').replace(/[*✦✶]/g, '★').replace(/[✩]/g, '☆');
    return s.split('\n')
      .map(function(l) { return l.replace(/[ \t ]+/g, ' ').trim(); })
      .filter(function(l) { return l.length > 0; });
  }

  function lineWidthMm(line) {
    var em = 0;
    for (var i = 0; i < line.length; i++) em += (GLYPH_EM[line[i]] || 0.75);
    em += ATELIER.TRACKING_EM * Math.max(line.length - 1, 0);
    return em * EM_MM;
  }

  function stockFor(ch, set) {
    set = set || ATELIER;
    if (/[A-Z]/.test(ch)) return set.STOCK_LETTER;
    if (/[0-9]/.test(ch)) return set.STOCK_DIGIT;
    if (RE_STAR.test(ch)) return Infinity;   // fers individuels
    return set.STOCK_SPECIAL[ch] != null ? set.STOCK_SPECIAL[ch] : 0;
  }
  // Une ligne qui est une date (1999, 28.06.1999, 2026-07-06…) : comme pour le motif Date,
  // ni contrôle de largeur ni contrôle de stock — l'atelier marque en deux frappes si nécessaire
  var RE_DATE_LINE = /^\d{1,4}([.\-]\d{1,4}){0,2}$/;
  function isDateLine(line) { return RE_DATE_LINE.test(line) && (line.match(/\d/g) || []).length >= 4; }

  function stockError(lines, set) {
    for (var i = 0; i < lines.length; i++) {
      if (isDateLine(lines[i])) continue;
      var counts = {};
      lines[i].replace(/ /g, '').split('').forEach(function(ch) { counts[ch] = (counts[ch] || 0) + 1; });
      for (var ch in counts) {
        var max = stockFor(ch, set);
        if (counts[ch] > max) {
          var where = lines.length > 1 ? T('stock_where', { line: lines[i] }) : '';
          return T('stock_error', { c: ch, n: counts[ch], where: where, max: max });
        }
      }
    }
    return null;
  }

  function analyzeTexte() {
    var lines = normalizeText(state.texte);
    var res = { lines: lines, stamped: 0, error: null };
    if (!lines.length) { res.error = T('text_empty'); return res; }
    res.stamped = countPriced(lines.join(''));

    var bad = [];
    lines.join('').split('').forEach(function(ch) {
      if (!RE_ALLOWED_CHAR.test(ch) && bad.indexOf(ch) === -1) bad.push(ch);
    });
    if (bad.length) {
      res.error = T(bad.length > 1 ? 'chars_bad_other' : 'chars_bad_one', { c: bad.join(' ') });
      return res;
    }
    var orient = state.orientation === 'vertical' ? ATELIER.VERTICAL : ATELIER.HORIZONTAL;
    if (lines.length > orient.maxLines) {
      res.error = T(state.orientation === 'vertical' ? 'max_lines_v' : 'max_lines_h', { n: orient.maxLines });
      return res;
    }
    if (res.stamped > ATELIER.MAX_CHARS) {
      res.error = T('max_chars', { n: ATELIER.MAX_CHARS, s: ATELIER.STAR_WEIGHT });
      return res;
    }
    for (var i = 0; i < lines.length; i++) {
      var maxMm = (isDateLine(lines[i]) && state.orientation !== 'vertical')
        ? Math.max(orient.usableMm, ATELIER.DATE_MAX_MM) : orient.usableMm;
      if (lineWidthMm(lines[i]) > maxMm) {
        res.error = T(state.orientation === 'vertical' ? 'line_long_v' : 'line_long_h', { line: lines[i] });
        return res;
      }
    }
    res.error = stockError(lines);
    return res;
  }

  function updateTexteFeedback() {
    if (state.motif !== 'texte') return;
    var a = analyzeTexte();
    if (texteCounter) {
      texteCounter.textContent = T(a.lines.length > 1 ? 'counter_other' : 'counter_one',
        { n: a.stamped, max: ATELIER.MAX_CHARS, l: a.lines.length });
    }
    // Erreur affichée en direct sauf « vide » (réservée au clic)
    var live = a.lines.length ? a.error : null;
    showError(texteInput, texteError, live);
  }

  /* ── Validation ────────── */
  // Initiales : 1 à 3 lettres, point facultatif après chacune (pas de « · » ni d'accent au composteur)
  var RE_INITIALES = /^[A-ZÇ]\.?([A-ZÇ]\.?){0,2}$/;
  function initialesValue() {
    return normalizeText(state.initiales).join('').replace(/ /g, '');
  }
  function validateInitiales() {
    var v = initialesValue();
    if (!v) return T('initials_empty');
    if (!RE_INITIALES.test(v)) return T('initials_format');
    return stockError([v]);
  }
  // Date grande (4 mm) : séparateurs point ou tiret — date petite (1,6 mm) : barre oblique uniquement
  var RE_ANNEE = /^\d{4}$/;
  var RE_DATE_GRANDE = /^(\d{2}[.\-]\d{2}[.\-](\d{2}|\d{4})|\d{4}[.\-]\d{2}[.\-]\d{2})$/;
  var RE_DATE_PETITE = /^\d{2}\/\d{2}\/(\d{2}|\d{4})$/;
  var DATE_FORMATS = {
    grande: { re: RE_DATE_GRANDE, example: '28.06.1999', hint: T('date_hint_large') },
    petite: { re: RE_DATE_PETITE, example: '28/06/1999', hint: T('date_hint_small') },
  };
  function isSmallDate() { return state.motif === 'date4' && state.dateSize === 'petite'; }
  function dateWidthError(val) {
    var v = (val || '').trim();
    if (!v) return null;
    var w = lineWidthMm(v) * capMm() / ATELIER.CAP_MM;
    return w > ATELIER.DATE_MAX_MM ? T('date_too_long') : null;
  }
  function validateDate(val) {
    var v = (val || '').trim();
    if (!v) return T('date_empty');
    var f = DATE_FORMATS[state.dateSize] || DATE_FORMATS.grande;
    // Le format d'abord (ex. « 28/06/1999 » en grande taille : barres obliques non disponibles), puis la largeur.
    // Dates : pas de contrôle de stock — l'atelier marque en deux frappes si nécessaire
    if (!RE_ANNEE.test(v) && !f.re.test(v)) return T('date_format', { hint: f.hint }) + (state.dateSize === 'petite' ? T('date_slashes') : '');
    return dateWidthError(v);
  }
  function capMm() {
    if (isSmallDate()) return ATELIER.SMALL.CAP_MM;
    return ATELIER.CAP_MM;
  }
  // Hauteur d'une ligne (mm) : celle des lettres, ou celle d'une étoile si la ligne en contient
  function lineHeightMm(line) { return RE_STAR.test(line) ? Math.max(ATELIER.STAR_MM, capMm()) : capMm(); }
  // Position (mm) du centre de chaque ligne par rapport au centre de la première
  function lineOffsetsMm(lines) {
    var y = 0, out = [0];
    for (var i = 1; i < lines.length; i++) {
      var a = lineHeightMm(lines[i - 1]), b = lineHeightMm(lines[i]);
      var pitch = (a === capMm() && b === capMm())
        ? ATELIER.LINE_PITCH_MM * capMm() / ATELIER.CAP_MM
        : (a + b) / 2 + ATELIER.LINE_GAP_MM;
      y += pitch; out.push(y);
    }
    return out;
  }
  // Découpe une ligne en segments texte / étoile
  function segments(line) {
    var out = [];
    line.split(/([★☆])/).forEach(function(part) {
      if (!part) return;
      out.push({ star: RE_STAR.test(part), text: part });
    });
    return out;
  }

  function showError(inputEl, errorEl, msg) {
    if (!inputEl || !errorEl) return;
    if (msg) { errorEl.textContent = msg; errorEl.hidden = false; inputEl.classList.add('mp-error'); }
    else     { errorEl.hidden = true; inputEl.classList.remove('mp-error'); }
  }
  function clearAllErrors() {
    showError(initialesInput, initialesError, null);
    showError(dateInput, dateError, null);
    showError(texteInput, texteError, null);
  }

  /* ── Libellé à marquer (lignes) ────────── */
  function labelLines(placeholder) {
    switch (state.motif) {
      case 'etoile': return [state.etoileType === 'contour' ? '☆' : '★'];
      case 'date4': var v = state.date.trim(); return v.length ? [v] : (placeholder ? ['···'] : []);
      case 'texte': var l = normalizeText(state.texte); return l.length ? l : (placeholder ? ['···'] : []);
      default: var v2 = initialesValue(); return v2.length ? [v2] : (placeholder ? ['···'] : []);
    }
  }

  /* ── SVG preview (miniature à l'échelle) ────────── */
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var SVG_U  = 2.7;   // unités SVG par mm (le marque-page fait 112 × 372 unités)
  var SVG_ANCHORS = {           // centre de la 1re ligne (haut) / de la dernière (bas) / centre (vertical)
    haut: { x: 60, y: 58 }, bas: { x: 60, y: 333 }, centre: { x: 60, y: 190 }, vertical: { x: 60, y: 190 },
  };

  function svgFill() {
    if (state.finition === 'dore') return '#9a7518';
    if (state.finition === 'argente') return '#8a929c';
    return '#3d2e1e';
  }

  // framed = true : cadre pointillé autour du bloc (marquage en cours d'édition)
  function drawSvgText(svg, lines, anchorKey, vertical, framed) {
    if (!svg) return;
    var g = document.createElementNS(SVG_NS, 'g');
    g.setAttribute('class', 'mp-svg-dyn');
    var a = SVG_ANCHORS[anchorKey] || SVG_ANCHORS.haut;
    var fontSize = capMm() / ATELIER.CAP_HEIGHT_EM * SVG_U;
    var starSize = ATELIER.STAR_MM / STAR_GLYPH_RATIO * SVG_U;
    var offs = lineOffsetsMm(lines).map(function(o) { return o * SVG_U; });
    var hFirst = lineHeightMm(lines[0]) * SVG_U, hLast = lineHeightMm(lines[lines.length - 1]) * SVG_U;
    var span = offs[offs.length - 1];
    // y du centre de la 1re ligne selon l'ancrage
    var y0 = (vertical || anchorKey === 'centre') ? a.y - span / 2
           : anchorKey === 'bas' ? a.y - span : a.y;
    // Cadre pointillé ajusté au bloc de texte
    var widest = Math.max.apply(null, lines.map(function(l) { return l === '···' ? 8 : lineWidthMm(l) * capMm() / ATELIER.CAP_MM; }));
    var boxW = Math.min(widest * SVG_U + 10, vertical ? 330 : 100);
    var r = document.createElementNS(SVG_NS, 'rect');
    r.setAttribute('x', (a.x - boxW / 2).toFixed(1));
    r.setAttribute('y', (y0 - hFirst / 2 - 5).toFixed(1));
    r.setAttribute('width', boxW.toFixed(1));
    r.setAttribute('height', (span + hFirst / 2 + hLast / 2 + 10).toFixed(1));
    r.setAttribute('rx', '4');
    r.setAttribute('fill', 'none');
    r.setAttribute('stroke', '#8b7355');
    r.setAttribute('stroke-width', '1');
    r.setAttribute('stroke-dasharray', '4 3');
    r.setAttribute('opacity', '0.5');
    if (framed !== false) g.appendChild(r);
    lines.forEach(function(line, i) {
      var t = document.createElementNS(SVG_NS, 'text');
      t.setAttribute('x', a.x);
      t.setAttribute('y', (y0 + offs[i]).toFixed(2));
      t.setAttribute('text-anchor', 'middle');
      t.setAttribute('dominant-baseline', 'central');
      t.setAttribute('font-family', "Cinzel, Georgia, 'Times New Roman', serif");
      t.setAttribute('font-weight', '600');
      t.setAttribute('font-size', fontSize.toFixed(2));
      t.setAttribute('letter-spacing', (ATELIER.TRACKING_EM * fontSize).toFixed(2));
      t.setAttribute('fill', svgFill());
      segments(line).forEach(function(seg) {
        var ts = document.createElementNS(SVG_NS, 'tspan');
        if (seg.star) { ts.setAttribute('font-size', starSize.toFixed(2)); ts.setAttribute('font-family', 'Georgia, serif'); }
        ts.textContent = seg.text;
        t.appendChild(ts);
      });
      g.appendChild(t);
    });
    if (vertical) g.setAttribute('transform', 'rotate(-90 ' + a.x + ' ' + a.y + ')');
    svg.appendChild(g);
    if (vertical) uprightSvgStars(g);
  }

  // En vertical : chaque étoile est redessinée à sa place, tournée de +90° pour rester droite
  function uprightSvgStars(g) {
    g.querySelectorAll('text').forEach(function(t) {
      var idx = 0;
      Array.prototype.slice.call(t.childNodes).forEach(function(ts) {
        var txt = ts.textContent || '';
        if (RE_STAR.test(txt)) {
          for (var k = 0; k < txt.length; k++) {
            var box;
            try { box = t.getExtentOfChar(idx + k); } catch (e) { return; }   // SVG masqué : sera redessiné
            if (!box || !box.width) return;
            var cx = box.x + box.width / 2, cy = parseFloat(t.getAttribute('y'));
            var s = document.createElementNS(SVG_NS, 'text');
            s.setAttribute('x', cx.toFixed(2)); s.setAttribute('y', cy.toFixed(2));
            s.setAttribute('text-anchor', 'middle'); s.setAttribute('dominant-baseline', 'central');
            s.setAttribute('font-family', 'Georgia, serif');
            s.setAttribute('font-size', ts.getAttribute('font-size'));
            s.setAttribute('fill', t.getAttribute('fill'));
            s.setAttribute('transform', 'rotate(90 ' + cx.toFixed(2) + ' ' + cy.toFixed(2) + ')');
            s.textContent = txt[k];
            g.appendChild(s);
          }
          ts.setAttribute('fill-opacity', '0');
        }
        idx += txt.length;
      });
    });
  }

  function updateSVG() {
    if (logoZone) {
      var logoSvg = logoZone.faceKey === faces[0].key ? svgRecto : svgVerso;
      if (logoSvg) logoSvg.querySelectorAll('text:not([id])').forEach(function(t) {
        if (!t.closest('.mp-svg-dyn')) t.style.display = state.noLogo ? 'none' : '';
      });
    }
    [svgRecto, svgVerso].forEach(function(svg) {
      if (svg) svg.querySelectorAll('.mp-svg-dyn').forEach(function(g) { g.remove(); });
    });
    var isFirstFace = state.face === faces[0].key;
    if (svgRecto) svgRecto.classList.toggle('mp-hidden', !isFirstFace);
    if (svgVerso) svgVerso.classList.toggle('mp-hidden', isFirstFace);
    // Tous les marquages sont dessinés sur leur face ; seul le marquage courant est encadré
    // et montre « ··· » tant qu'il est vide
    allMarkings().forEach(function(m, i) {
      withMarking(m, function() {
        var isCur = i === current;
        var lines = labelLines(isCur);
        if (!lines.length) return;
        var vertical = effectiveOrientation() === 'vertical';
        drawSvgText(state.face === faces[0].key ? svgRecto : svgVerso, lines, vertical ? 'vertical' : state.position, vertical, isCur);
      });
    });
    if (previewHint) previewHint.textContent = zoneLabel(state);
  }

  /* ── Overlay sur les photos produit ────────── */
  var BOOKMARK_RATIO = 0.77;   // hauteur du marque-page / hauteur de la photo

  var allOverlays = [];

  /* Construire la liste des zones overlay à partir de la config */
  function getOverlayZones() {
    var zones = [];
    faces.forEach(function(face) {
      var facePositions = allPositionsForFace(face.key);
      facePositions.forEach(function(pos) {
        var zoneKey = face.key + pos.charAt(0).toUpperCase() + pos.slice(1);
        if (overlayCoords[zoneKey]) {
          zones.push({ key: zoneKey, faceKey: face.key, position: pos, orientation: 'horizontal', coords: overlayCoords[zoneKey] });
        }
      });
      if (allOrientationsForFace(face.key).indexOf('vertical') !== -1) {
        var vKey = face.key + 'Vertical';
        zones.push({ key: vKey, faceKey: face.key, position: 'centre', orientation: 'vertical',
                     coords: overlayCoords[vKey] || { top: 50, left: 50 } });
      }
    });
    if (logoZone) zones.push(logoZone);
    return zones;
  }

  var overlayZones = getOverlayZones();

  function findImagesInContainer(container) {
    var allImgs = container.querySelectorAll('img');
    var isDocument = container === document;
    var result = {};

    allImgs.forEach(function(img) {
      if (isDocument && img.closest('.product-media-modal, product-modal')) return;
      var alt = (img.alt || '').toLowerCase();
      faces.forEach(function(face) {
        if (!result[face.key] && alt.includes(face.img_alt.toLowerCase())) {
          result[face.key] = img;
        }
      });
    });

    return result;
  }

  function sizeOverlayToImage(overlayDiv, img) {
    overlayDiv.style.left   = img.offsetLeft + 'px';
    overlayDiv.style.top    = img.offsetTop + 'px';
    overlayDiv.style.width  = img.offsetWidth + 'px';
    overlayDiv.style.height = img.offsetHeight + 'px';
  }

  function getImgContainer(img, isModal) {
    if (isModal) {
      var existingWrap = img.parentElement;
      if (existingWrap && existingWrap.classList.contains('mp-overlay-wrap')) return existingWrap;
      var wrap = document.createElement('div');
      wrap.className = 'mp-overlay-wrap';
      wrap.style.position = 'relative';
      wrap.style.display = 'inline-block';
      wrap.style.width = '100%';
      img.parentElement.insertBefore(wrap, img);
      wrap.appendChild(img);
      return wrap;
    }
    return img.closest('.product__media') || img.closest('.product-media-modal__content') || img.parentElement;
  }

  function createOverlayEl(container, coords, img, isModal, kind) {
    var overlay = document.createElement('div');
    overlay.className = 'mp-overlay';
    if (isModal && img) {
      sizeOverlayToImage(overlay, img);
      if (!img.complete) img.addEventListener('load', function() { sizeOverlayToImage(overlay, img); }, { once: true });
    }
    if (kind === 'logo') {
      overlay.className = 'mp-overlay mp-overlay--logo';
      var patch = document.createElement('span');
      patch.className = 'mp-logo-patch';
      overlay.appendChild(patch);
      container.appendChild(overlay);
      return { textEl: patch, overlayDiv: overlay };
    }
    var textEl = document.createElement('span');
    textEl.className = 'mp-overlay__text';
    textEl.style.top  = coords.top + '%';
    textEl.style.left = coords.left + '%';
    overlay.appendChild(textEl);
    container.appendChild(overlay);
    return { textEl: textEl, overlayDiv: overlay };
  }

  function setupOverlaysForImage(img, imgZones, context) {
    var isModal = context === 'modal';
    var container = getImgContainer(img, isModal);
    if (getComputedStyle(container).position === 'static') container.style.position = 'relative';

    imgZones.forEach(function(zone) {
      var exists = allOverlays.some(function(o) { return o.img === img && o.zoneKey === zone.key; });
      if (exists) return;
      var result = createOverlayEl(container, zone.coords, img, isModal, zone.kind);
      allOverlays.push({
        el: result.textEl, overlayDiv: result.overlayDiv,
        zoneKey: zone.key, faceKey: zone.faceKey, position: zone.position, orientation: zone.orientation,
        context: context, img: img, kind: zone.kind, coords: zone.coords,
      });
    });
  }

  function setupOverlaysInContainer(container, context) {
    var images = findImagesInContainer(container);
    overlayZones.forEach(function(zone) {
      var img = images[zone.faceKey];
      if (img) setupOverlaysForImage(img, [zone], context);
    });
  }

  function resizeModalOverlays() {
    allOverlays.forEach(function(o) {
      if (o.context === 'modal' && o.overlayDiv) sizeOverlayToImage(o.overlayDiv, o.img);
    });
    updateOverlays();
  }
  var resizeTimer;
  window.addEventListener('resize', function() { clearTimeout(resizeTimer); resizeTimer = setTimeout(resizeModalOverlays, 100); });

  function ensureAllModalImagesVisible(modalEl) {
    var content = modalEl.querySelector('.product-media-modal__content, .product-popup-modal__content');
    if (!content) return;
    content.querySelectorAll('[style*="display: none"], [style*="display:none"], [hidden]').forEach(function(el) {
      el.style.display = ''; el.removeAttribute('hidden');
    });
    content.querySelectorAll('deferred-media').forEach(function(dm) {
      if (!dm.classList.contains('loaded')) {
        var tpl = dm.querySelector('template');
        if (tpl) { dm.appendChild(tpl.content.cloneNode(true)); dm.classList.add('loaded'); }
      }
    });
    content.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
      img.loading = 'eager';
      if (!img.src && img.dataset.src) img.src = img.dataset.src;
    });
    content.querySelectorAll('template').forEach(function(tpl) {
      if (tpl.closest('deferred-media')) return;
      tpl.parentElement.insertBefore(tpl.content.cloneNode(true), tpl); tpl.remove();
    });
  }

  /* ── Scroll modal ────────── */
  function smoothScrollTo(scrollable, targetX, targetY, duration) {
    var startX = scrollable.scrollLeft, startY = scrollable.scrollTop;
    var dx = targetX - startX, dy = targetY - startY, start = null;
    function ease(t) { return 1 - Math.pow(1 - t, 3); }
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1), e = ease(p);
      scrollable.scrollLeft = startX + dx * e;
      scrollable.scrollTop  = startY + dy * e;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function activeZoneKey() {
    if (effectiveOrientation() === 'vertical') return state.face + 'Vertical';
    return state.face + state.position.charAt(0).toUpperCase() + state.position.slice(1);
  }

  function scrollModalToFace(modalEl) {
    // Trouver la zone correspondant à face + position (ou vertical)
    var targetZoneKey = activeZoneKey();
    var overlay = allOverlays.find(function(o) {
      return o.context === 'modal' && o.zoneKey === targetZoneKey;
    });
    if (!overlay) return;
    setTimeout(function() {
      var scrollable = overlay.el.closest('.product-media-modal__content')
                    || overlay.el.closest('.product-popup-modal__content') || modalEl;
      var elRect = overlay.el.getBoundingClientRect();
      var containerRect = scrollable.getBoundingClientRect();
      var targetY = scrollable.scrollTop  + (elRect.top  + elRect.height / 2 - containerRect.top)  - (containerRect.height / 2);
      var targetX = scrollable.scrollLeft + (elRect.left + elRect.width  / 2 - containerRect.left) - (containerRect.width  / 2);
      smoothScrollTo(scrollable, Math.max(0, targetX), Math.max(0, targetY), 600);
    }, 200);
  }

  /* ── Détection du clic loupe ────────── */
  var lastClickedPhotoFace = null;
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-media-id], .product__media-item, .product__modal-opener, .product-media-modal__opener');
    if (!trigger) { lastClickedPhotoFace = null; return; }
    var mediaItem = trigger.closest('.product__media-item, li') || trigger;
    var img = mediaItem.querySelector('img');
    if (!img) { lastClickedPhotoFace = null; return; }
    var alt = (img.alt || '').toLowerCase();
    lastClickedPhotoFace = null;
    faces.forEach(function(face) {
      if (alt.includes(face.img_alt.toLowerCase())) lastClickedPhotoFace = face.key;
    });
  }, true);

  function setupOverlays() {
    var hasPageOverlays = allOverlays.some(function(o) { return o.context === 'page'; });
    if (hasPageOverlays) return;
    setupOverlaysInContainer(document, 'page');
    if (allOverlays.length > 0) console.log('[mp-perso] ' + allOverlays.length + ' overlays page créés');

    var modalEl = document.querySelector('product-modal, .product-media-modal');
    if (modalEl) {
      var modalObserver = new MutationObserver(function() {
        var isOpen = modalEl.classList.contains('active') || modalEl.hasAttribute('open')
                  || getComputedStyle(modalEl).display !== 'none';
        if (!isOpen) {
          allOverlays = allOverlays.filter(function(o) {
            if (o.context === 'modal') { o.overlayDiv.remove(); return false; }
            return true;
          });
          modalEl.querySelectorAll('.mp-overlay-wrap').forEach(function(wrap) {
            var img = wrap.querySelector('img');
            if (img) wrap.parentElement.insertBefore(img, wrap);
            wrap.remove();
          });
          return;
        }
        requestAnimationFrame(function() {
          ensureAllModalImagesVisible(modalEl);
          var hasModalOverlays = allOverlays.some(function(o) { return o.context === 'modal'; });
          if (!hasModalOverlays) setupOverlaysInContainer(modalEl, 'modal');
          updateOverlays();
          setTimeout(resizeModalOverlays, 300);
          var shouldScroll = state.active && lastClickedPhotoFace === state.face;
          if (shouldScroll) scrollModalToFace(modalEl);
        });
      });
      modalObserver.observe(modalEl, { attributes: true, attributeFilter: ['class', 'open', 'style'] });
    }
  }

  /* Taille de police : 1 em = EM_MM mm, rapporté à la hauteur du marque-page sur la photo */
  function computeFontSizePx(img) {
    var imgHeight = img.offsetHeight || img.clientHeight || img.naturalHeight || 354;
    var bookmarkPx = imgHeight * BOOKMARK_RATIO;
    var emMm = capMm() / ATELIER.CAP_HEIGHT_EM;
    return Math.max(bookmarkPx * emMm / ATELIER.BOOKMARK_MM.h, 3);
  }

  /* Ancrage : haut → la 1re ligne reste en place et le texte descend ;
               bas  → la dernière ligne reste en place et le texte monte ;
               vertical → centré puis tourné (lecture de bas en haut). */
  function overlayTransform(item, lines) {
    var em = capMm() / ATELIER.CAP_HEIGHT_EM;   // mm par em du texte
    var hFirst = (lineHeightMm(lines[0] || '') / 2 / em).toFixed(4) + 'em';
    var hLast  = (lineHeightMm(lines[lines.length - 1] || '') / 2 / em).toFixed(4) + 'em';
    if (item.orientation === 'vertical') return 'translate(-50%, -50%) rotate(-90deg)';
    if (item.position === 'bas')  return 'translate(-50%, calc(-100% + ' + hLast + '))';
    if (item.position === 'haut') return 'translate(-50%, -' + hFirst + ')';
    return 'translate(-50%, -50%)';
  }
  function escapeHtml(t) { return t.replace(/[&<>"]/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  // Chaque ligne = un bloc dont la hauteur et l'écart suivent la géométrie réelle (étoile 7,5 mm, lettres 4 mm)
  // En vertical, chaque étoile est redressée (+90°) : sa branche du haut pointe vers le haut du marque-page
  function overlayHtml(lines, vertical) {
    var em = capMm() / ATELIER.CAP_HEIGHT_EM;
    var offs = lineOffsetsMm(lines);
    var starEm = (ATELIER.STAR_MM / STAR_GLYPH_RATIO / em).toFixed(4);
    return lines.map(function(line, i) {
      var h = lineHeightMm(line) / em;
      var gap = i === 0 ? 0 : (offs[i] - offs[i - 1] - lineHeightMm(lines[i - 1]) / 2 - lineHeightMm(line) / 2) / em;
      var inner = segments(line).map(function(seg) {
        return seg.star
          ? '<span style="font-size:' + starEm + 'em;font-family:Georgia,serif;letter-spacing:0;vertical-align:middle;line-height:1' +
            (vertical ? ';display:inline-block;transform:rotate(90deg)' : '') + '">' + seg.text + '</span>'
          : escapeHtml(seg.text);
      }).join('');
      return '<div style="height:' + h.toFixed(4) + 'em;line-height:' + h.toFixed(4) + 'em;margin-top:' + gap.toFixed(4) + 'em;white-space:pre">' + inner + '</div>';
    }).join('');
  }

  /* Masque du logo : le morceau de photo situé src_dy % plus haut (cuir sans marquage) est recopié
     par-dessus le logo, avec des bords fondus. Aucun traitement d'image : simple fond CSS. */
  function layoutLogoPatch(item) {
    var div = item.overlayDiv, patch = item.el, c = item.coords;
    div.style.display = state.noLogo ? '' : 'none';
    if (!state.noLogo) return;
    var W = div.offsetWidth || item.img.offsetWidth, H = div.offsetHeight || item.img.offsetHeight;
    if (!W || !H) return;
    var src = item.img.currentSrc || item.img.src;
    var x0 = W * (c.left - c.width / 2) / 100, y0 = H * (c.top - c.height / 2) / 100;
    patch.style.left = x0.toFixed(1) + 'px';
    patch.style.top = y0.toFixed(1) + 'px';
    patch.style.width = (W * c.width / 100).toFixed(1) + 'px';
    patch.style.height = (H * c.height / 100).toFixed(1) + 'px';
    if (src && patch.dataset.src !== src) { patch.style.backgroundImage = 'url("' + src.replace(/"/g, '%22') + '")'; patch.dataset.src = src; }
    patch.style.backgroundSize = W.toFixed(1) + 'px ' + H.toFixed(1) + 'px';
    patch.style.backgroundPosition = (-x0).toFixed(1) + 'px ' + (-(y0 - H * c.src_dy / 100)).toFixed(1) + 'px';
  }

  function updateOverlays() {
    var list = allMarkings();
    allOverlays.forEach(function(item) {
      if (item.kind === 'logo') { layoutLogoPatch(item); return; }
      // Le marquage placé sur cette zone, s'il y en a un
      var idx = -1;
      for (var i = 0; i < list.length; i++) { if (zoneKeyOf(list[i]) === item.zoneKey) { idx = i; break; } }
      if (!state.active || idx === -1) { item.overlayDiv.style.display = 'none'; return; }
      withMarking(list[idx], function() {
        var lines = labelLines(false);
        if (!lines.length) { item.overlayDiv.style.display = 'none'; return; }
        var el = item.el;
        el.innerHTML = overlayHtml(lines, item.orientation === 'vertical');
        el.style.fontSize = computeFontSizePx(item.img).toFixed(2) + 'px';
        el.style.lineHeight = 'normal';
        el.style.letterSpacing = ATELIER.TRACKING_EM + 'em';
        el.style.paddingLeft = ATELIER.TRACKING_EM + 'em';   // compense l'espacement après la dernière lettre
        el.style.whiteSpace = 'pre';
        el.style.textAlign = 'center';
        el.style.transform = overlayTransform(item, lines);
        el.style.transformOrigin = '50% 50%';
        var finCls = state.finition === 'dore'    ? ' mp-overlay__text--gold'
                   : state.finition === 'argente' ? ' mp-overlay__text--silver'
                   : isDarkLeather                ? ' mp-overlay__text--dark'
                   : isDarkBrown                  ? ' mp-overlay__text--dark-brown'
                   : '';
        el.className = 'mp-overlay__text' + finCls;
        el.style.opacity = '1';
        item.overlayDiv.style.display = '';
      });
    });
  }

  /* ── Face pills dynamiques ────────── */
  // Une face a de la place pour le marquage courant si une position (ou le vertical) y est libre
  function faceHasRoom(faceKey) {
    if (positionsForFace(faceKey).some(function(pos) { return placementFree(horizontalAt(faceKey, pos), current); })) return true;
    return isVerticalMarking(state) && otherMarkings(current).every(function(o) { return o.face !== faceKey; });
  }
  // Place le marquage courant sur une position libre de sa face (après changement de face ou de logo)
  function ensureFreePosition() {
    if (isVerticalMarking(state)) return;
    var list = positionsForFace(state.face);
    if (list.indexOf(state.position) !== -1 && placementFree(horizontalAt(state.face, state.position), current)) return;
    for (var i = 0; i < list.length; i++) {
      if (placementFree(horizontalAt(state.face, list[i]), current)) { state.position = list[i]; return; }
    }
  }
  function renderFacePills() {
    if (!facePills || !faceSection) return;
    if (faces.length <= 1) {
      faceSection.classList.add('mp-hidden');
      state.face = faces[0].key;
      return;
    }
    faceSection.classList.remove('mp-hidden');
    facePills.innerHTML = '';
    faces.forEach(function(face) {
      var id = 'mp-face-' + face.key;
      var label = document.createElement('label');
      label.className = 'mp-perso__pill-option';
      label.setAttribute('for', id);
      var input = document.createElement('input');
      input.type = 'radio'; input.id = id; input.name = 'mp-face';
      input.value = face.key; input.className = 'mp-perso__radio-pill';
      input.checked = face.key === state.face;
      input.disabled = face.key !== state.face && !faceHasRoom(face.key);
      var span = document.createElement('span');
      span.className = 'mp-perso__pill';
      span.textContent = face.label;
      label.appendChild(input); label.appendChild(span);
      facePills.appendChild(label);

      input.addEventListener('change', function() {
        state.face = face.key;
        refreshLayoutSections();   // peut repasser en horizontal si la face a déjà un marquage
        ensureFreePosition();
        renderPositionPills();
        refreshLayoutSections();
        scrollToFacePhoto();
        refreshAll();
      });
    });
  }

  /* ── Masquer les motifs non activés ────────── */
  function applyMotifVisibility() {
    if (!motifChoices) return;
    var allMotifLabels = motifChoices.querySelectorAll('[data-motif]');
    var visibleCount = 0;
    allMotifLabels.forEach(function(label) {
      var m = label.dataset.motif;
      if (m === 'initiales') { visibleCount++; return; } // toujours visible
      var show = motifs.indexOf(m) !== -1;
      label.style.display = show ? '' : 'none';
      if (show) visibleCount++;
    });
    motifChoices.style.gridTemplateColumns = 'repeat(' + visibleCount + ', 1fr)';

    // Masquer date / texte si non activés
    if (motifs.indexOf('date4') === -1 && dateSection) dateSection.style.display = 'none';
    if (motifs.indexOf('texte') === -1 && texteSection) texteSection.style.display = 'none';

    // Mettre à jour le texte intro
    if (introText) {
      var parts = [T('intro_initials')];
      if (motifs.indexOf('texte') !== -1) parts.push(T('intro_text'));
      if (motifs.indexOf('date4') !== -1) parts.push(T('intro_date'));
      if (motifs.indexOf('etoile') !== -1) parts.push(T('intro_star'));
      var motifText = parts.length === 1 ? parts[0]
                    : parts.slice(0, -1).join(', ') + T('intro_or') + parts[parts.length - 1];
      introText.textContent = motifText + T('intro_suffix');
    }
  }

  /* ── Position pills dynamiques ────────── */
  function renderPositionPills() {
    if (!positionPills || !positionSection) return;
    var facePositions = positionsForFace(state.face);
    ensureFreePosition();

    // Masquer si une seule position
    if (facePositions.length <= 1) {
      positionSection.classList.add('mp-hidden');
      state.position = facePositions[0] || 'haut';
      return;
    }

    positionSection.classList.remove('mp-hidden');
    positionPills.innerHTML = '';
    if (facePositions.indexOf(state.position) === -1) state.position = facePositions[0];

    facePositions.forEach(function(pos) {
      var id = 'mp-pos-' + pos;
      var label = document.createElement('label');
      label.className = 'mp-perso__pill-option';
      label.setAttribute('for', id);

      var input = document.createElement('input');
      input.type = 'radio'; input.id = id; input.name = 'mp-position';
      input.value = pos; input.className = 'mp-perso__radio-pill';
      input.checked = pos === state.position;
      // Emplacement déjà occupé par un autre marquage
      input.disabled = pos !== state.position && !placementFree(horizontalAt(state.face, pos), current);

      var span = document.createElement('span');
      span.className = 'mp-perso__pill';
      span.textContent = positionLabel(pos);

      label.appendChild(input);
      label.appendChild(span);
      positionPills.appendChild(label);

      input.addEventListener('change', function() {
        state.position = pos;
        refreshAll();
      });
    });
  }

  /* ── Sections dépendant du motif / de la face / de l'orientation ── */
  function refreshLayoutSections() {
    var isTexte = state.motif === 'texte';
    // Le vertical occupe toute la face : seulement si aucun autre marquage n'y est
    var faceFree = otherMarkings(current).every(function(o) { return o.face !== state.face; });
    var allowed = orientationsForFace(state.face).filter(function(o) { return o !== 'vertical' || faceFree; });
    if (allowed.indexOf(state.orientation) === -1) state.orientation = 'horizontal';

    if (orientSection) {
      orientSection.classList.toggle('mp-hidden', !isTexte || allowed.length <= 1);
      orientSection.querySelectorAll('input[name="mp-orientation"]').forEach(function(r) {
        var ok = allowed.indexOf(r.value) !== -1;
        r.closest('label').style.display = ok ? '' : 'none';
        r.checked = r.value === state.orientation;
      });
    }
    var vertical = effectiveOrientation() === 'vertical';
    if (positionSection) {
      var multiPos = positionsForFace(state.face).length > 1;
      positionSection.classList.toggle('mp-hidden', vertical || !multiPos);
    }
    if (texteHint) {
      var o = vertical ? ATELIER.VERTICAL : ATELIER.HORIZONTAL;
      texteHint.textContent = vertical
        ? T('text_hint_v', { n: o.maxLines })
        : T('text_hint_h', { n: o.maxLines });
    }
  }

  /* ── Desktop / scroll / sticky ────────── */
  function isDesktop() { return window.innerWidth >= 750; }
  function scrollToModule() {
    if (!isDesktop()) return;
    var headerEl = document.querySelector('.shopify-section-header-sticky');
    var headerH = headerEl ? headerEl.offsetHeight : 0;
    window.scrollTo({ top: window.pageYOffset + module.getBoundingClientRect().top - headerH, behavior: 'smooth' });
  }
  function getPageTop(el) { var top = 0; while (el) { top += el.offsetTop; el = el.offsetParent; } return top; }

  function scrollToFacePhoto() {
    if (!isDesktop()) return;
    if (state.face === faces[0].key) { scrollToModule(); return; }
    // Trouver le premier overlay de la face active sur la page
    var overlay = allOverlays.find(function(o) { return o.context === 'page' && o.faceKey === state.face; });
    if (!overlay) return;
    var photoItem = overlay.img.closest('li, .product__media-item') || overlay.img;
    var moduleViewportTop = module.getBoundingClientRect().top;
    var photoPageTop = getPageTop(photoItem);
    var targetScroll = Math.max(0, photoPageTop - moduleViewportTop);
    if (infoWrapper) {
      var neededBottom = targetScroll + window.innerHeight;
      var currentBottom = getPageTop(infoWrapper) + infoWrapper.scrollHeight;
      if (neededBottom > currentBottom) {
        var pad = parseFloat(infoWrapper.style.paddingBottom) || 0;
        infoWrapper.style.paddingBottom = (pad + neededBottom - currentBottom) + 'px';
      }
    }
    window.scrollTo({ top: targetScroll, behavior: 'smooth' });
  }

  /* Lien « Voir l'aperçu sur la photo » : équivaut au clic sur la loupe de la photo de la face active
     (ouvre la photo en grand, avec la personnalisation). À défaut de loupe, fait défiler jusqu'à la photo. */
  function showPreview(e) {
    if (e) e.preventDefault();
    updateOverlays();
    var overlay = allOverlays.find(function(o) { return o.context === 'page' && o.faceKey === state.face; })
               || allOverlays.find(function(o) { return o.context === 'page'; });
    var opener = overlay && overlay.img.closest('modal-opener');
    var zoomBtn = opener && opener.querySelector('button.product__media-toggle, button');
    if (zoomBtn) { zoomBtn.click(); return; }
    var target = overlay ? (overlay.img.closest('li, .product__media-item') || overlay.img)
                         : (document.querySelector('.product__media-wrapper') || svgRecto);
    if (!target) return;
    try { target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' }); }
    catch (err) { target.scrollIntoView(); }
  }

  var stickyInner = module.closest('.product__column-sticky, .product__info-container');
  var infoWrapper = stickyInner ? stickyInner.parentElement : module.closest('.product__info-wrapper');

  function extendStickyRoom(show) {
    if (!isDesktop() || !infoWrapper) return;
    if (show) {
      var mw = document.querySelector('.product__media-wrapper');
      var neededBottom = mw ? getPageTop(mw) + mw.scrollHeight + window.innerHeight
                           : getPageTop(infoWrapper) + infoWrapper.scrollHeight + window.innerHeight;
      infoWrapper.style.paddingBottom = Math.max(0, neededBottom - getPageTop(infoWrapper) - infoWrapper.scrollHeight) + 'px';
    } else {
      infoWrapper.style.paddingBottom = '';
    }
  }

  /* ── Toggle / Confirm ────────── */
  function togglePanel(show) {
    state.active = show;
    if (show) {
      panel.classList.remove('mp-hidden'); panel.setAttribute('aria-hidden', 'false');
      checkbox.setAttribute('aria-expanded', 'true');
      extendStickyRoom(true); scrollToModule();
      if (mobileHint) mobileHint.classList.remove('mp-hidden');
    } else {
      panel.classList.add('mp-hidden'); panel.setAttribute('aria-hidden', 'true');
      checkbox.setAttribute('aria-expanded', 'false');
      extendStickyRoom(false);
      if (mobileHint) mobileHint.classList.add('mp-hidden');
      clearAllErrors(); hideConfirm();
      // L'option sans logo vit dans le module : le refermer la retire (pas d'option cachée)
      if (state.noLogo) { checkLogoRadio(false); setNoLogo(false, true); }
    }
    updateOverlays();
  }
  var confirmTimer;
  function showConfirm(cartCount, text) {
    if (!confirmEl) return;
    var ct = confirmEl.querySelector('.mp-perso__confirm-text');
    if (ct && text) ct.textContent = text;
    if (cartLink) cartLink.textContent = T('view_cart_count', { n: cartCount });
    confirmEl.classList.remove('mp-hidden');
    clearTimeout(confirmTimer); confirmTimer = setTimeout(hideConfirm, 5000);
  }
  function hideConfirm() { if (confirmEl) confirmEl.classList.add('mp-hidden'); clearTimeout(confirmTimer); }

  function refreshAll() {
    hideConfirm(); updateTexteFeedback(); updatePrice(); updateSVG(); updateOverlays(); updateAddBtn(); renderMarkingsUI();
  }

  /* ── Properties ────────── */
  // index / count : numéro du marquage et nombre total (propriété « Marquage : 2 / 3 » si plusieurs)
  function buildProperties(index, count) {
    var motifLabels = { initiales: T('v_initials'), etoile: T('v_star'), date4: T('v_date'), texte: T('v_text') };
    var finitionLabels = { 'ton-sur-ton': T('v_blind'), 'dore': T('v_gold'), 'argente': T('v_silver') };
    var vertical = effectiveOrientation() === 'vertical';
    var props = {};
    props[T('p_product')] = productTitle;
    // Pas de numéro « Marquage : 1 / 2 » : il deviendrait faux si le client retire une ligne au panier.
    // Face et Position identifient chaque marquage ; l'ordre des lignes suit l'ordre des marquages.
    props[T('p_motif')] = motifLabels[state.motif] || state.motif;
    props[T('p_finish')] = finitionLabels[state.finition] || state.finition;
    props[T('p_face')] = faceLabel(state.face);
    if (state.motif === 'texte') {
      var lines = normalizeText(state.texte);
      props[T('p_text')] = lines.join(' / ');
      props[T('p_orientation')] = vertical ? T('v_vertical') : T('v_horizontal');
      props[T('p_lines')] = String(lines.length);
      props[T('p_chars')] = String(countPriced(lines.join('')));
      var nPleine = (lines.join('').match(/★/g) || []).length, nContour = (lines.join('').match(/☆/g) || []).length;
      if (nPleine || nContour) {
        props[T('p_stars')] = [nPleine ? T.n('v_solid', nPleine) : '', nContour ? T('v_outline', { n: nContour }) : '']
          .filter(Boolean).join(', ') + ' (' + fmtMm(ATELIER.STAR_MM) + ' mm)';
      }
    }
    if (!vertical) props[T('p_position')] = positionLabel(state.position);
    if (state.noLogo) props[T('p_logo')] = T('v_nologo');
    if (state.motif === 'initiales') props[T('p_initials')] = initialesValue();
    if (state.motif === 'etoile') props[T('p_star')] = (state.etoileType === 'contour' ? T('v_star_outline') : T('v_star_solid')) + ' (' + fmtMm(ATELIER.STAR_MM) + ' mm)';
    if (state.motif === 'date4') {
      props[T('p_date')] = state.date.trim();
      props[T('p_size')] = state.dateSize === 'petite' ? T('v_size_small') : T('v_size_large');
    }
    return props;
  }

  /* ── Form / cart ────────── */
  function findProductForm() {
    var btn = document.querySelector('button[name="add"][type="submit"]');
    if (btn) { var f = btn.closest('form'); if (f) return f; }
    var forms = document.querySelectorAll('form[id^="product-form"]');
    for (var i = 0; i < forms.length; i++) { if (!forms[i].id.includes('installment')) return forms[i]; }
    var carts = document.querySelectorAll('form[action*="/cart/add"]');
    for (var j = 0; j < carts.length; j++) { if (!(carts[j].id || '').includes('installment')) return carts[j]; }
    return null;
  }
  function getProductVariantId() {
    var f = findProductForm(); if (!f) return null;
    var i = f.querySelector('input[name="id"]'); return i ? i.value : null;
  }
  function getQuantity() {
    var f = findProductForm(); if (!f) return 1;
    var i = f.querySelector('input[name="quantity"]'); return i ? (parseInt(i.value, 10) || 1) : 1;
  }

  function refreshCartIcon(callback) {
    var cp = fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) { return c.item_count; }).catch(function() { return null; });
    var sp = fetch('/?sections=header').then(function(r) { return r.json(); }).then(function(s) {
      var h = s['header']; if (!h) return;
      var t = document.createElement('div'); t.innerHTML = h;
      var nb = t.querySelector('#cart-icon-bubble'), ob = document.getElementById('cart-icon-bubble');
      if (nb && ob) ob.innerHTML = nb.innerHTML;
    }).catch(function() {});
    Promise.all([cp, sp]).then(function(r) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (callback) callback(r[0]);
    });
  }

  // Option sans logo sans aucun marquage : seul le marque-page est ajouté (gratuit)
  var ADD_LABEL = T('add'), ADD_LABEL_NOLOGO = T('add_nologo');
  function markingEmpty() {
    switch (state.motif) {
      case 'etoile': return false;
      case 'date4':  return !state.date.trim();
      case 'texte':  return normalizeText(state.texte).length === 0;
      default:       return !initialesValue();
    }
  }
  function noLogoProps() { var o = {}; o[T('p_logo')] = T('v_nologo'); return o; }
  function allEmpty() { return allMarkings().every(function(m) { return withMarking(m, markingEmpty); }); }
  // « Sans logo » seul : un unique marquage, laissé vide. Avec plusieurs marquages, chacun doit être rempli.
  function noLogoOnly() { return state.noLogo && allMarkings().length === 1 && allEmpty(); }
  function addLabel() {
    if (editKey) return T('update_cart');
    if (noLogoOnly()) return ADD_LABEL_NOLOGO;
    var n = allMarkings().length;
    return n > 1 ? T('add_n', { n: n }) : ADD_LABEL;
  }
  function updateAddBtn() { if (addBtn && !addBtn.disabled) addBtn.textContent = addLabel(); }

  function addNoLogoOnly() {
    var mainVariantId = getProductVariantId();
    if (!mainVariantId) { console.error('[mp-perso] Variant ID introuvable'); return; }
    addBtn.disabled = true; addBtn.textContent = T('adding'); hideConfirm();
    var wasEdit = !!editKey;
    removeEdited()
    .then(function() {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(mainVariantId, 10), quantity: getQuantity(), properties: noLogoProps() }),
      });
    })
    .then(function(r) { if (!r.ok) throw new Error('Erreur produit: ' + r.status); return r.json(); })
    .then(function() {
      if (wasEdit) return backToCart();
      refreshCartIcon(function(count) {
        addBtn.disabled = false; addBtn.textContent = addLabel();
        if (count !== null) showConfirm(count, T('added_nologo'));
      });
    })
    .catch(function(e) {
      console.error('[mp-perso]', e);
      addBtn.disabled = false; addBtn.textContent = addLabel();
    });
  }

  // Erreur du marquage courant (state), avec le champ à signaler ; null si tout va bien
  function currentMarkingError() {
    if (state.motif === 'initiales') {
      var e1 = validateInitiales(); if (e1) return { msg: e1, input: initialesInput, error: initialesError };
    }
    if (state.motif === 'date4') {
      var e2 = validateDate(state.date); if (e2) return { msg: e2, input: dateInput, error: dateError };
    }
    if (state.motif === 'texte') {
      var e3 = analyzeTexte().error; if (e3) return { msg: e3, input: texteInput, error: texteError };
    }
    return null;
  }

  function handleAddToCart() {
    if (noLogoOnly()) { clearAllErrors(); addNoLogoOnly(); return; }
    var list = allMarkings();
    // Chaque marquage doit être rempli et valide, et à un emplacement qui lui est propre :
    // au premier problème, l'éditeur bascule sur le marquage concerné et montre l'erreur
    for (var i = 0; i < list.length; i++) {
      var clash = list.some(function(o, j) { return j !== i && conflicts(list[i], o); });
      var err = withMarking(list[i], currentMarkingError);
      if (clash && !err) err = { msg: T('zone_taken'), input: null, error: null };
      if (err) {
        if (i !== current) switchToMarking(i);
        clearAllErrors();
        if (err.input) { showError(err.input, err.error, err.msg); err.input.focus(); }
        else showMarkingsError(err.msg);
        return;
      }
    }
    clearAllErrors();
    var mainVariantId = getProductVariantId();
    if (!mainVariantId) { console.error('[mp-perso] Variant ID introuvable'); return; }
    var qty = getQuantity();

    var persoItems = [];
    for (var k = 0; k < list.length; k++) {
      var item = withMarking(list[k], function() {
        var v = currentVariant();
        return v ? { id: parseInt(v.id, 10), quantity: qty, properties: buildProperties(k, list.length) } : null;
      });
      if (!item) { console.error('[mp-perso] Aucune variante de personnalisation ne correspond (marquage ' + (k + 1) + ')'); return; }
      persoItems.push(item);
    }
    addBtn.disabled = true; addBtn.textContent = T('adding'); hideConfirm();

    // Propriété cachée « _mp » (identifiant unique, invisible au panier et au paiement) : sans elle, Shopify
    // fusionnerait ce marque-page avec un marque-page identique déjà au panier (sans personnalisation, ou
    // avec une autre), et les personnalisations se retrouveraient rattachées à une ligne « × 2 ».
    var mainProps = state.noLogo ? noLogoProps() : {};
    mainProps._mp = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var mainItem = { id: parseInt(mainVariantId, 10), quantity: qty, properties: mainProps };

    function post(body) {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
      });
    }
    // Ajout séquentiel historique (perso puis produit) : utilisé en repli si le rattachement échoue.
    function addSequential() {
      var chain = Promise.resolve();
      persoItems.forEach(function(pi) {
        chain = chain.then(function() { return post(pi); })
          .then(function(r) { if (!r.ok) throw new Error('Erreur perso: ' + r.status); return r.json(); });
      });
      return chain.then(function() { return post(mainItem); })
        .then(function(r) { if (!r.ok) throw new Error('Erreur produit: ' + r.status); return r.json(); });
    }

    // Lignes de panier imbriquées (Dawn ≥ 15.4) : chaque marquage est rattaché au marque-page
    // (parent_id) en un seul appel. Ils s'affichent sous lui et disparaissent s'il est retiré du panier.
    var nested = persoItems.map(function(pi) {
      var o = {}; for (var key in pi) o[key] = pi[key];
      o.parent_id = mainItem.id; return o;
    });

    var wasEdit = !!editKey;
    // Modification depuis le panier : l'ancien article (et ses personnalisations) est d'abord retiré,
    // sinon Shopify fusionnerait le nouveau marque-page avec l'ancien
    removeEdited()
    .then(function() { return post({ items: [mainItem].concat(nested) }); })
    .then(function(r) {
      if (r.ok) return r.json();
      console.warn('[mp-perso] Rattachement refusé (' + r.status + '), ajout séquentiel');
      return addSequential();
    })
    .then(function() {
      if (wasEdit) return backToCart();
      refreshCartIcon(function(count) {
        addBtn.disabled = false; addBtn.textContent = addLabel();
        if (count !== null) showConfirm(count, list.length > 1 ? T('added_n', { n: list.length }) : T('added'));
      });
    })
    .catch(function(e) {
      console.error('[mp-perso]', e);
      addBtn.disabled = false; addBtn.textContent = addLabel();
    });
  }

  /* ── Marquages : barre (1 · Haut du recto ×), ajout, bascule, retrait ────────── */
  var markingsBar = null, markingsChips = null, markingsError = null, addMarkingBtn = null;
  function buildMarkingsUI() {
    var options = module.querySelector('.mp-perso__col-options');
    if (!options) return;
    markingsBar = document.createElement('div');
    markingsBar.className = 'mp-perso__section mp-perso__markings mp-hidden';
    markingsBar.id = 'mp-markings';
    markingsChips = document.createElement('div');
    markingsChips.className = 'mp-perso__pill-group';
    markingsChips.setAttribute('role', 'group');
    markingsChips.setAttribute('aria-label', T('markings_label'));
    markingsError = document.createElement('p');
    markingsError.className = 'mp-perso__error';
    markingsError.setAttribute('role', 'alert');
    markingsError.hidden = true;
    markingsBar.appendChild(markingsChips);
    markingsBar.appendChild(markingsError);
    options.insertBefore(markingsBar, options.firstChild);

    addMarkingBtn = document.createElement('button');
    addMarkingBtn.type = 'button';
    addMarkingBtn.className = 'mp-perso__add-marking mp-hidden';
    addMarkingBtn.id = 'mp-add-marking';
    addMarkingBtn.textContent = T('add_marking');
    addMarkingBtn.addEventListener('click', addMarking);
    var action = options.querySelector('.mp-perso__action');
    options.insertBefore(addMarkingBtn, action || null);
  }
  function showMarkingsError(msg) {
    if (!markingsError) return;
    markingsError.textContent = msg || '';
    markingsError.hidden = !msg;
  }
  function renderMarkingsUI() {
    if (!markingsBar) return;
    var list = allMarkings();
    if (addMarkingBtn) addMarkingBtn.classList.toggle('mp-hidden', !canAddMarking());
    markingsBar.classList.toggle('mp-hidden', list.length < 2);
    if (list.length < 2) { showMarkingsError(null); return; }
    markingsChips.innerHTML = '';
    list.forEach(function(m, i) {
      var chip = document.createElement('span');
      chip.className = 'mp-perso__marking' + (i === current ? ' is-current' : '');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mp-perso__pill mp-perso__marking-pick';
      b.setAttribute('aria-pressed', i === current ? 'true' : 'false');
      b.textContent = (i + 1) + ' · ' + zoneLabel(m);
      b.addEventListener('click', function() { switchToMarking(i); });
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'mp-perso__marking-remove';
      x.setAttribute('aria-label', T('remove_marking', { n: i + 1 }));
      x.title = T('remove_marking', { n: i + 1 });
      x.textContent = '×';
      x.addEventListener('click', function() { removeMarking(i); });
      chip.appendChild(b); chip.appendChild(x);
      markingsChips.appendChild(chip);
    });
  }
  function applyMotifSections() {
    var isDate = state.motif === 'date4', isInit = state.motif === 'initiales', isTexte = state.motif === 'texte';
    var etoileSection = $('mp-etoile-section');
    if (etoileSection) etoileSection.classList.toggle('mp-hidden', state.motif !== 'etoile');
    if (initialesSection) initialesSection.classList.toggle('mp-hidden', !isInit);
    if (dateSection) dateSection.classList.toggle('mp-hidden', !isDate);
    if (texteSection) texteSection.classList.toggle('mp-hidden', !isTexte);
  }
  // Recopie le marquage courant (state) dans tous les champs de l'éditeur
  function loadMarkingIntoUI() {
    module.querySelectorAll('input[name="mp-motif"]').forEach(function(r) { r.checked = r.value === state.motif; });
    applyMotifSections();
    if (initialesInput) initialesInput.value = state.initiales;
    module.querySelectorAll('input[name="mp-date-size"]').forEach(function(r) { r.checked = r.value === state.dateSize; });
    var f = DATE_FORMATS[state.dateSize] || DATE_FORMATS.grande;
    var hint = $('mp-date-hint');
    if (hint) hint.textContent = f.hint;
    if (dateInput) { dateInput.placeholder = f.example; dateInput.value = state.date; }
    if (texteInput) texteInput.value = state.texte;
    module.querySelectorAll('input[name="mp-etoile-type"]').forEach(function(r) { r.checked = r.value === state.etoileType; });
    module.querySelectorAll('input[name="mp-finition"]').forEach(function(r) { r.checked = r.value === state.finition; });
    clearAllErrors(); showMarkingsError(null);
    renderFacePills(); renderPositionPills(); refreshLayoutSections();
    refreshAll();
  }
  function setStateFrom(m) { MARK_KEYS.forEach(function(k) { state[k] = m[k]; }); }
  function switchToMarking(j) {
    if (j === current || !markings[j]) return;
    saveCurrent();
    current = j;
    setStateFrom(markings[j]);
    loadMarkingIntoUI();
  }
  function addMarking() {
    if (!canAddMarking()) return;
    var p = freePlacement(-1);
    saveCurrent();
    markings.push({ motif: 'initiales', initiales: '', date: '', dateSize: 'grande', etoileType: 'pleine', texte: '',
                    orientation: 'horizontal', face: p.face, position: p.position, finition: 'ton-sur-ton' });
    current = markings.length - 1;
    setStateFrom(markings[current]);
    loadMarkingIntoUI();
    revealEditorTop();
    if (initialesInput && isDesktop()) initialesInput.focus({ preventScroll: true });
  }
  // Après l'ajout d'un marquage : la page reste sur le module (pas de saut vers la photo de la face) ;
  // on remonte seulement, en douceur, jusqu'à la barre des marquages si elle est sortie de l'écran
  // (elle vient d'apparaître au-dessus et a poussé le contenu vers le bas).
  function revealEditorTop() {
    if (!markingsBar) return;
    var headerEl = document.querySelector('.shopify-section-header-sticky');
    var headerH = headerEl ? headerEl.offsetHeight : 0;
    var top = markingsBar.getBoundingClientRect().top;
    if (top >= headerH + 8 && top <= window.innerHeight * 0.5) return;
    window.scrollTo({ top: Math.max(0, window.pageYOffset + top - headerH - 16), behavior: 'smooth' });
  }
  function removeMarking(i) {
    saveCurrent();
    if (markings.length < 2) return;
    markings.splice(i, 1);
    if (i < current || current >= markings.length) current = Math.max(0, current - 1);
    setStateFrom(markings[current]);
    loadMarkingIntoUI();
  }

  /* ── Listeners UI ────────── */
  function bindUI() {
    checkbox.addEventListener('change', function() { togglePanel(checkbox.checked); });
    addBtn.addEventListener('click', handleAddToCart);

    document.querySelectorAll('input[name="mp-motif"]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        state.motif = radio.value;
        applyMotifSections();
        clearAllErrors();
        refreshLayoutSections();
        refreshAll();
      });
    });
    if (initialesInput) initialesInput.addEventListener('input', function() {
      state.initiales = initialesInput.value;
      showError(initialesInput, initialesError, null); refreshAll();
    });
    document.querySelectorAll('input[name="mp-date-size"]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        state.dateSize = radio.value;
        var f = DATE_FORMATS[state.dateSize];
        var hint = $('mp-date-hint');
        if (hint) hint.textContent = f.hint;
        if (dateInput) dateInput.placeholder = f.example;
        showError(dateInput, dateError, null); refreshAll();
      });
    });
    if (dateInput) dateInput.addEventListener('input', function() {
      state.date = dateInput.value;
      showError(dateInput, dateError, dateWidthError(state.date)); refreshAll();
    });
    if (texteInput) texteInput.addEventListener('input', function() {
      state.texte = texteInput.value; refreshAll();
    });
    // Boutons ★ / ☆ : insèrent l'étoile à l'emplacement du curseur (début, milieu, fin, ou seule sur une ligne)
    module.querySelectorAll('[data-star]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (!texteInput) return;
        var ch = btn.getAttribute('data-star');
        var a = texteInput.selectionStart != null ? texteInput.selectionStart : texteInput.value.length;
        var b = texteInput.selectionEnd != null ? texteInput.selectionEnd : a;
        texteInput.value = texteInput.value.slice(0, a) + ch + texteInput.value.slice(b);
        texteInput.focus();
        texteInput.setSelectionRange(a + ch.length, a + ch.length);
        texteInput.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
    document.querySelectorAll('input[name="mp-etoile-type"]').forEach(function(radio) {
      radio.addEventListener('change', function() { state.etoileType = radio.value; refreshAll(); });
    });
    document.querySelectorAll('input[name="mp-orientation"]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        state.orientation = radio.value;
        refreshLayoutSections();
        refreshAll();
      });
    });
    document.querySelectorAll('input[name="mp-finition"]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        state.finition = radio.value; refreshAll();
      });
    });
  }

  /* ── Option « sans logo » (gratuite, utilisable aussi sans personnalisation) ────────── */
  var noLogoRow = $('mp-nologo-row'), logoRadios = module.querySelectorAll('input[name="mp-logo"]');
  // Pilules « Avec logo » / « Sans logo »
  function checkLogoRadio(noLogo) {
    logoRadios.forEach(function(r) { r.checked = (r.value === 'sans') === !!noLogo; });
  }
  // Ajoute / retire properties[Logo] dans le formulaire du produit (bouton « Ajouter au panier » du thème)
  function syncLogoInput() {
    var f = findProductForm(); if (!f) return;
    var inp = f.querySelector('input.mp-nologo-input');
    if (state.noLogo && !inp) {
      inp = document.createElement('input');
      inp.type = 'hidden'; inp.name = 'properties[' + T('p_logo') + ']'; inp.value = T('v_nologo'); inp.className = 'mp-nologo-input';
      f.appendChild(inp);
    } else if (!state.noLogo && inp) { inp.remove(); }
  }
  // force = false (choix « Avec logo » par le client) : refusé si un marquage n'a plus de place ;
  // force = true (fermeture du module) : les marquages sans place sont retirés
  function setNoLogo(on, force) {
    if (!on && state.noLogo && !force && !relocationPossible()) {
      checkLogoRadio(true);
      showMarkingsError(T('logo_needs_room'));
      return;
    }
    state.noLogo = !!on;
    showMarkingsError(null);
    if (!state.noLogo) relocateMarkings();
    syncLogoInput();
    renderFacePills(); renderPositionPills(); refreshLayoutSections(); refreshAll();
  }
  // Avec logo, le bas de la face du logo et son écriture verticale ne sont plus disponibles :
  // les marquages qui s'y trouvaient sont déplacés vers un emplacement libre, ou retirés s'il n'y en a plus
  // Peut-on revenir au logo sans perdre de marquage ? (simulation sur une copie)
  function relocationPossible() {
    var list = allMarkings().map(function(m) { var c = {}; for (var k in m) c[k] = m[k]; return c; });
    var was = state.noLogo; state.noLogo = false;
    var spots = [];
    faces.forEach(function(f) { positionsForFace(f.key).forEach(function(pos) { spots.push(horizontalAt(f.key, pos)); }); });
    var placed = [], toMove = [];
    var fits = function(c) { return placed.every(function(o) { return !conflicts(c, o); }); };
    // 1) les marquages qui restent valables gardent leur place ; 2) les autres cherchent une place libre
    list.forEach(function(m) {
      var okV = !isVerticalMarking(m) || orientationsForFace(m.face).indexOf('vertical') !== -1;
      var okPos = isVerticalMarking(m) || positionsForFace(m.face).indexOf(m.position) !== -1;
      if (okV && okPos && fits(m)) placed.push(m); else toMove.push(m);
    });
    var ok = toMove.every(function(m) {
      var spot = spots.filter(fits)[0];
      if (!spot) return false;
      placed.push(spot); return true;
    });
    state.noLogo = was;
    return ok;
  }
  function relocateMarkings() {
    saveCurrent();
    withDepth++;   // on modifie `markings` directement : pas de recopie de `state` pendant la boucle
    for (var i = markings.length - 1; i >= 0; i--) {
      var m = markings[i];
      var badV = isVerticalMarking(m) && orientationsForFace(m.face).indexOf('vertical') === -1;
      var badPos = !isVerticalMarking(m) && positionsForFace(m.face).indexOf(m.position) === -1;
      if (!badV && !badPos) continue;
      if (badV) m.orientation = 'horizontal';
      var p = (positionsForFace(m.face).indexOf(m.position) !== -1 && placementFree(m, i)) ? m : freePlacement(i);
      if (p) { m.face = p.face; m.position = p.position; }
      else if (markings.length > 1) { markings.splice(i, 1); if (current >= i && current > 0) current--; }
    }
    withDepth--;
    setStateFrom(markings[current]);
    renderMarkingsUI();
  }
  function initNoLogo() {
    if (!noLogoRow || !logoRadios.length) return;
    if (!logoZone) { noLogoRow.classList.add('mp-hidden'); return; }
    noLogoRow.classList.remove('mp-hidden');
    checkLogoRadio(false);
    logoRadios.forEach(function(r) {
      r.addEventListener('change', function() { if (r.checked) setNoLogo(r.value === 'sans'); });
    });
    // Le thème peut redessiner le formulaire (changement de variante) : on revérifie avant l'envoi
    document.addEventListener('submit', function(e) {
      if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) syncLogoInput();
    }, true);
    document.addEventListener('click', function(e) {
      if (e.target.closest && e.target.closest('button[name="add"]')) syncLogoInput();
    }, true);
  }

  /* ── Modifier un article du panier ──────────
     Le panier relie le marque-page et ses lignes « Personnalisation » à la fiche avec ?mp_edit=<clé de la ligne>.
     Les marquages sont relus dans les propriétés des lignes (libellés de la langue du site), le module
     s'ouvre avec eux ; « Mettre à jour le panier » remplace l'ancien article puis renvoie au panier. */
  var editKey = null, editNoteEl = null;
  function removeEdited() {
    if (!editKey) return Promise.resolve(false);
    var key = editKey;
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).then(function(r) { if (!r.ok) throw new Error('Erreur retrait: ' + r.status); editKey = null; return true; });
  }
  function backToCart() {
    location.href = (cartLink && cartLink.getAttribute('href')) || '/cart';
  }
  function invert(o) { var r = {}; for (var k in o) r[o[k]] = k; return r; }
  function markingFromProps(p) {
    var motif = invert({ initiales: T('v_initials'), etoile: T('v_star'), date4: T('v_date'), texte: T('v_text') })[p[T('p_motif')]];
    var face = (faces.find(function(f) { return f.label === p[T('p_face')]; }) || {}).key;
    if (!motif || !face) return null;
    var m = { motif: motif, initiales: '', date: '', dateSize: 'grande', etoileType: 'pleine', texte: '',
              orientation: 'horizontal', face: face, position: 'haut',
              finition: invert({ 'ton-sur-ton': T('v_blind'), 'dore': T('v_gold'), 'argente': T('v_silver') })[p[T('p_finish')]] || 'ton-sur-ton' };
    var posLabel = p[T('p_position')];
    ['haut', 'bas', 'centre', 'gauche', 'droite'].forEach(function(k) { if (posLabel && positionLabel(k) === posLabel) m.position = k; });
    if (motif === 'initiales') m.initiales = p[T('p_initials')] || '';
    if (motif === 'etoile') m.etoileType = (p[T('p_star')] || '').indexOf(T('v_star_outline')) === 0 ? 'contour' : 'pleine';
    if (motif === 'date4') { m.date = p[T('p_date')] || ''; m.dateSize = p[T('p_size')] === T('v_size_small') ? 'petite' : 'grande'; }
    if (motif === 'texte') {
      m.texte = (p[T('p_text')] || '').split(' / ').join('\n');
      m.orientation = p[T('p_orientation')] === T('v_vertical') ? 'vertical' : 'horizontal';
    }
    return m;
  }
  function showEditNote(on) {
    var options = module.querySelector('.mp-perso__col-options');
    if (!options) return;
    if (!editNoteEl) {
      editNoteEl = document.createElement('p');
      editNoteEl.className = 'mp-perso__edit-note';
      var txt = document.createElement('span');
      txt.textContent = T('editing_note') + ' ';
      var cancel = document.createElement('button');
      cancel.type = 'button';
      cancel.className = 'mp-perso__edit-cancel';
      cancel.textContent = T('editing_cancel');
      cancel.addEventListener('click', function() { editKey = null; showEditNote(false); updateAddBtn(); });
      editNoteEl.appendChild(txt); editNoteEl.appendChild(cancel);
      options.insertBefore(editNoteEl, options.firstChild);
    }
    editNoteEl.classList.toggle('mp-hidden', !on);
  }
  function initEditFromCart() {
    var key = null;
    try { key = new URLSearchParams(location.search).get('mp_edit'); } catch (e) { return; }
    if (!key) return;
    try {   // le paramètre a servi : on le retire de l'adresse (un rechargement ne relance pas la modification)
      var u = new URL(location.href); u.searchParams.delete('mp_edit'); history.replaceState(history.state, '', u.toString());
    } catch (e) { /* adresse laissée telle quelle */ }
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var parent = (cart.items || []).find(function(i) { return i.key === key; });
      if (!parent || String(parent.product_id) !== String(module.dataset.productId || '')) return;
      var kids = cart.items.filter(function(i) { return i.parent_relationship && i.parent_relationship.parent_key === key; });
      var list = kids.map(function(k) {
        var props = k.properties || {};
        // « Marquage : n / N » n'existe que sur les lignes ajoutées avant la v18.2 ; sinon l'ordre du panier est gardé
        return { m: markingFromProps(props), n: parseInt(String(props[T('p_marking')] || '').split('/')[0], 10) || 0 };
      }).filter(function(x) { return x.m; }).sort(function(a, b) { return a.n - b.n; }).map(function(x) { return x.m; });
      var noLogo = !!(parent.properties && parent.properties[T('p_logo')]);
      if (!list.length && !noLogo) return;
      editKey = key;
      var f = findProductForm(), q = f && f.querySelector('input[name="quantity"]');
      if (q) q.value = parent.quantity;
      if (list.length) importState({ v: 2, active: true, noLogo: noLogo, current: 0, markings: list });
      else { checkbox.checked = true; togglePanel(true); if (logoZone) { checkLogoRadio(true); setNoLogo(true); } }
      showEditNote(true);
      updateAddBtn();
      console.info('[mp-perso] Modification de l\'article du panier (' + list.length + ' marquage(s))');
    }).catch(function(e) { console.warn('[mp-perso] Panier illisible', e); });
  }

  /* ── Échange avec les pastilles de coloris (assets/coloris-gamme.js) ────────── */
  // Exporte / réimporte tous les marquages, pour les reprendre sur la fiche d'un autre coloris
  function exportState() {
    return { v: 2, active: state.active, noLogo: state.noLogo, current: current, markings: allMarkings() };
  }
  function motifAllowed(m) { return m === 'initiales' || motifs.indexOf(m) !== -1; }
  function importState(s) {
    if (!s || !s.markings || !s.markings.length) return false;
    if (s.active && !state.active) { checkbox.checked = true; togglePanel(true); }
    if (s.noLogo && logoZone && !state.noLogo) { checkLogoRadio(true); setNoLogo(true); }
    // On ne garde que les marquages possibles sur ce produit, sans chevauchement
    var kept = [];
    s.markings.slice(0, MAX_MARKINGS).forEach(function(m) {
      var c = {};
      MARK_KEYS.forEach(function(k) { c[k] = m[k] != null ? m[k] : state[k]; });
      if (!faces.some(function(f) { return f.key === c.face; })) return;
      if (!motifAllowed(c.motif)) c.motif = 'initiales';
      if (isVerticalMarking(c) && orientationsForFace(c.face).indexOf('vertical') === -1) c.orientation = 'horizontal';
      if (!isVerticalMarking(c) && positionsForFace(c.face).indexOf(c.position) === -1) return;
      if (kept.some(function(o) { return conflicts(c, o); })) return;
      kept.push(c);
    });
    if (!kept.length) return false;
    markings = kept;
    current = Math.min(Math.max(+s.current || 0, 0), kept.length - 1);
    setStateFrom(markings[current]);
    loadMarkingIntoUI();
    return true;
  }
  window.mpPerso = { exportState: exportState, importState: importState };

  // La miniature collante se cale sous l'en-tête du site quand il est affiché (Dawn le masque en
  // descendant et le réaffiche en remontant) : position recalculée au défilement
  var stickyRaf = 0;
  function setStickyTop() {
    stickyRaf = 0;
    var h = document.querySelector('.section-header, sticky-header');
    var bottom = h ? h.getBoundingClientRect().bottom : 0;
    module.style.setProperty('--mp-sticky-top', (Math.max(0, Math.round(bottom)) + 12) + 'px');
  }
  function queueStickyTop() { if (!stickyRaf) stickyRaf = requestAnimationFrame(setStickyTop); }

  /* ── Init ────────── */
  var mobileHint = null;
  function init() {
    document.body.classList.add('mp-perso-page');
    var previewLink = $('mp-perso-preview-link');
    if (previewLink) previewLink.addEventListener('click', showPreview);
    panel.classList.add('mp-hidden'); checkbox.checked = false; state.active = false;
    buildMarkingsUI();
    initNoLogo();
    renderFacePills();
    renderPositionPills();
    applyMotifVisibility();
    refreshLayoutSections();
    hideConfirm(); updatePrice(); updateSVG(); setupOverlays(); updateOverlays(); bindUI(); renderMarkingsUI();
    initEditFromCart();
    setStickyTop();
    window.addEventListener('resize', queueStickyTop);
    window.addEventListener('scroll', queueStickyTop, { passive: true });
    // l'en-tête glisse en 0,15 s environ : on recale une fois l'animation finie
    window.addEventListener('scroll', function() { clearTimeout(setStickyTop.t); setStickyTop.t = setTimeout(setStickyTop, 300); }, { passive: true });
    // Redessiner une fois Cinzel chargée (l'aperçu SVG dépend de la police)
    if (document.fonts && document.fonts.load) {
      document.fonts.load('600 16px Cinzel').then(function() { updateSVG(); updateOverlays(); }).catch(function() {});
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();